module.exports = __webpack_public_path__ + "static/media/emojis2_10.5b8e5846.svg";